var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"500px","text-align":"center","line-height":"500px","font-weight":"bold","font-size":"100px"}},[_vm._v(" 404 "),_c('span',{staticStyle:{"font-size":"50px"}},[_vm._v(" 页面不存在")])])
}]

export { render, staticRenderFns }